export const styles = {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '14px',
  },
  title: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '146%',
    color: '#131F1E',
  },
  usersListContainer: {
    display: 'flex',
    width: '100%',
    gap: '14px',
    flexWrap: 'wrap',
  },
  tagContainer: {
    display: 'flex',
    width: 'calc((100% - 14px) / 2)',
    minWidth: 'calc((100% - 14px) / 2)',
    height: '50px',
    gap: '14px',
    flexDirection: 'row',
    padding: '2px 6px 2px 15px',
    borderRadius: '8px',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.10)',
    alignItems: 'center',
    cursor: 'pointer',
  },
  avatarContainer: {
    display: 'flex',
    width: '28px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  userName: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '146%',
    color: '#23252F',
    userSelect: 'none',
  },
};
